import {
  ref, watch, computed, onMounted,
} from '@vue/composition-api';
import store from '@/store';
import { formatDateBr } from '@core/utils/filter';
import SLSTemplateImagemService from '@/services/SistemaDKP/sls-template-imagem.service';
// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import SLSMarcaService from '@/services/SistemaDKP/sls-marca.service';

export default function useUsersList(nameModule) {
  // Use toast
  const toast = useToast();
  const slsTemplateImagemService = new SLSTemplateImagemService();
  const slsMarcaService = new SLSMarcaService();
  const refDataTableTemplateImagem = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'familia_comercial_id', label: 'Cód. Referência', sortable: false },
    { key: 'familia_comercial_descricao', label: 'Referência', sortable: true },
    { key: 'cod_marca', label: 'Cód. Marca', sortable: true },
    { key: 'des_marca', label: 'Desc. Marca', sortable: true },
    { key: 'actions', label: 'Ações', sortable: false },
  ];
  const perPage = ref(10);
  const totalTemplateImagem = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('log_img_id');
  const isSortDirDesc = ref(true);
  const marcaFilter = ref(null);
  const referenciaFilter = ref({
    familia_comercial_id: null,
  });
  const marcaOptions = ref([]);
  const referenciaOptions = ref([]);

  const dataMeta = computed(() => {
    const localItemsCount = refDataTableTemplateImagem.value ? refDataTableTemplateImagem.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalTemplateImagem.value,
    };
  });

  const refetchData = () => {
    refDataTableTemplateImagem.value.refresh();
  };

  const handleClearFilters = () => {
    marcaFilter.value = null;
    referenciaFilter.value = null;
    referenciaOptions.value = [];

    refetchData();
  };

  const carregarReferencias = async (codMarca) => {
    await slsTemplateImagemService.loadFamiliaComercial(codMarca);
  };
  watch([currentPage, perPage, searchQuery], () => {
    refetchData();
  });

  // watch([marcaFilter, referenciaFilter], async () => {
  //     await carregarReferencias(marcaFilter.value)
  //     marcaFilter.value = {label: marcaFilter.value, value: marcaFilter.value}
  // })

  const pagination = computed({
    get() {
      return store.getters['slsTemplateImagem/getFilters'];
    },
    set(value) {
      store.commit('slsTemplateImagem/setFilters', value);
    },
  });

  const fetchTemplateImagem = (ctx, callback) => {
    try {
      store.commit('slsTemplateImagem/setShowLoading', true);

      const params = {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      };

      if (marcaFilter.value) {
        params.cod_marca = marcaFilter.value;
      }

      if (referenciaFilter.value && referenciaFilter.value.familia_comercial_id) {
        params.familia_comercial_id = referenciaFilter.value.familia_comercial_id;
      }

      store
        .dispatch('slsTemplateImagem/findAll', params)
        .then((response) => {
          const paginations = response.paginations || response;
          const { data } = response;
          const page = Number(paginations.page) || currentPage.value;
          const currentPerPage = Number(paginations.perPage) || perPage.value;
          const total = Number(paginations.total) || 0;
          currentPage.value = page;
          perPage.value = currentPerPage;
          totalTemplateImagem.value = total;
          callback(data);
        })
        .catch((error) => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error ao carregar dados',
              text: error.message,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        })
        .finally(() => {
          store.commit('slsTemplateImagem/setShowLoading', false);
        });
    } catch (e) {
      store.commit('slsTemplateImagem/setShowLoading', false);
    }
  };

  onMounted(async () => {
    await slsMarcaService.findAll();
    marcaOptions.value = store.getters['slsMarca/getEsMarcas'];
  });

  return {
    fetchTemplateImagem,
    tableColumns,
    perPage,
    currentPage,
    totalTemplateImagem,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refDataTableTemplateImagem,

    refetchData,
    handleClearFilters,

    // Extra Filters
    marcaFilter,
    referenciaFilter,
    marcaOptions,
    referenciaOptions,
    carregarReferencias,
  };
}
